import { Admin } from "./Admin";

class ConfigSystemsEndpoint extends Admin {
    constructor() {
        super("/ConfigSystems");
    }
    getAllConfig = (filter) => this.SearchAUTH(filter, null, null, true);

    saveConfig = (id, body) => this.PatchAuthen(`(${id})`, body);

}

export default new ConfigSystemsEndpoint()